export const UP_ARROW_KEY = 38
export const DOWN_ARROW_KEY = 40
export const ENTER_KEY = 13
export const RESULT_SIZE = 5
